import { render } from "./HeroiconsOutlineInformationCircle.vue?vue&type=template&id=574d08d0"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineInformationCircle.vue"]])

export default __exports__